import { CustomerKycError } from './customer-kyc.js';
/** MoonPay documents unavailable and verification_rejected as final outcomes, not corrections. */
export function isCustomerKycTerminal(status, error) {
    return status === 'unavailable' || error === 'rejected';
}
export function customerKycFailure(cause) {
    if (!(cause instanceof CustomerKycError))
        return 'unavailable';
    if (['forbidden', 'unauthorized', 'connection_required'].includes(cause.code))
        return 'access';
    if (['verification_rejected', 'unsupported_country'].includes(cause.code))
        return 'rejected';
    if ([
        'invalid_request',
        'unprocessable_entity',
        'requirements_incomplete',
        'country_mismatch',
    ].includes(cause.code))
        return 'invalid';
    return 'unavailable';
}
